<template>
  <div class="btn_main flex_start">
    <template v-for="(btn, index) in btnList">
      <div
        v-if="!btn.hidden"
        :key="index"
        class="btn_box"
        :class="[
          btn.type == 'plain' ? 'borde_btn' : '',
          btn.disabled ? 'boxDisable' : '',
          btn.name == 'キャンセル' ? 'cancelColor' : '',
        ]"
        :style="{
          '--bg-color': btn.bg ? btn.bg : null,
          '--hover-color': btn.hover,
          '--default-color': btn.defaultColor,
          width: btn.widht == 'auto' ? btn.widht : btn.widht + 'px',
          paddingLeft: btn.widht == 'auto' ? '7px' : 0,
          paddingRight: btn.widht == 'auto' ? '7px' : 0,
        }"
        @click="open(btn)"
      >
        <div class="flex_start icon_box">
          <svg-icon
            v-if="btn.icon"
            :icon-class="btn.icon"
            class="iconName"
          ></svg-icon>
          <span class="btnname">{{ btn.name }}</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'VabButton',
    inject: {
      vm: { default: '' },
    },
    props: {
      btnList: {
        type: Array,
        default: () => {
          ;[]
        },
      },
      row: {
        type: Object,
        default: () => {},
      },
    },
    methods: {
      open(row) {
        if (row.disabled) return
        if (this.$baseLodash.isEmpty(row.msg)) {
          row.click && row.click(row)
          return
        }
        this.$confirm({
          msg: row.msg,
          yesText: row.msgOk ? row.msgOk : row.name,
          yesColor: row.bg ? row.bg : '#0060c2',
          msgWidth: row.msgWidth ? row.msgWidth : '104px',
          yes: () => {
            if (this.row) {
              let data = this.$baseLodash.clone(this.row)
              this.$delete(data, 'btnList')
              row.rowData = data
            }
            row.click && row.click(row)
            if (this.vm && this.vm[row.submitMethod]) {
              this.vm[row.submitMethod](row)
            }
          },
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  $bgColor: var(--bg-color, #0060c2);
  $hoverColor: var(--hover-color, #0071ee);
  $defaultColor: var(--default-color, #fff);
  .btn_main :last-child {
    margin-right: 0px;
  }
  .btn_box {
    width: 104px;
    height: 32px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: $defaultColor;
    margin-right: 8px;

    @if ($bgColor) {
      background: $bgColor;
    } @else {
      background: #0060c2;
    }
    &:hover {
      @if $hoverColor {
        background: $hoverColor;
      } @else {
        background: #0071ee;
      }
    }
    &.borde_btn {
      background: #fff;
      border: 1px solid $defaultColor;
      color: $defaultColor;
      &:hover {
        border: 1px solid $hoverColor;
        color: $hoverColor;
      }
    }
    &.boxDisable {
      background: #efefef !important;
      border-color: #efefef !important;
      color: #a1a1a1;
      cursor: not-allowed;
      &:hover {
        background: inherit;
        color: #a1a1a1;
        cursor: default !important;
      }
    }
    .icon_box {
      align-items: center;
      .btnname {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 150%;
      }
      .iconName {
        font-size: 15px;
        margin-right: 5px;
      }
    }
  }
  .no_margin .btn_box {
    margin-left: 0;
  }
  .cancelColor {
    background: #ffffff;
    color: #848484;
    &:hover {
      background: #f7f7f7;
      color: #a1a1a1;
    }
  }
</style>
